import { render, staticRenderFns } from "./selfchart.vue?vue&type=template&id=b8d5d162"
import script from "./selfchart.vue?vue&type=script&lang=js"
export * from "./selfchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports